import { Component } from '@angular/core';

@Component({
  selector: 'app-toolbar-scope',
  templateUrl: './toolbar-scope.component.html',
  styleUrls: ['./toolbar-scope.component.scss']
})
export class ToolbarScopeComponent {

}
